<template>
  <div v-if="audioURL">
    <audio :src="audioURL" class="whatsapp-audio-bubble" controls />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    audioURL: {
      type: String,
      default: null,
    },
  },
})
</script>
<style scoped>
/* WhatsApp-like Audio Bubble Styling */
.whatsapp-audio-bubble {
  display: flex;
  /* Use flexbox for layout */
  flex-direction: column;
  /* Stack audio and download link vertically */
  align-items: center;
  /* Center items horizontally */
  background-color: #dcf8c6;
  /* WhatsApp light green for sent messages */
  border-radius: 8px 8px 8px 8px;
  /* Rounded corners, adjust if you want a specific "tail" */
  padding: 8px 12px;
  /* Inner padding */
  max-width: 340px;
  /* Typical WhatsApp audio message width */
  margin: 10px auto;
  /* Center the bubble and add vertical margin */
  box-shadow: 0 1px 0.5px rgba(0, 0, 0, 0.13);
  /* Subtle shadow */
}

.whatsapp-audio-bubble audio {
  width: 100%;
  /* Make audio player fill the bubble width */
  min-width: 250px;
  /* Ensure it doesn't get too small */
  /* These properties might have limited effect on native controls */
  background-color: transparent;
  /* Try to make background transparent */
  border-radius: 5px;
  /* Apply some border-radius */
  outline: none;
  /* Remove outline on focus */
  margin-bottom: 5px;
  /* Space between audio and download link */
}

/* You might need to target shadow DOM parts for deeper styling,
   but this is not reliably cross-browser compatible with plain CSS.
   For example (this won't work in all browsers):
   .whatsapp-audio-bubble audio::-webkit-media-controls-panel {
     background-color: #DCF8C6;
   }
   .whatsapp-audio-bubble audio::-webkit-media-controls-play-button {
     color: #333;
   }
*/

.whatsapp-audio-bubble a {
  display: inline-block;
  margin-top: 5px;
  /* Adjust spacing */
  font-size: 0.9em;
  color: #007bff;
  /* Keep original download link color or change to WhatsApp blue */
  text-decoration: none;
  border-top: 1px solid rgba(0, 0, 0, 0.05);
  /* Subtle separator */
  padding-top: 5px;
  width: 100%;
  /* Make download link span full width */
}

.whatsapp-audio-bubble a:hover {
  text-decoration: underline;
}
</style>
